<div class="app-main__inner">
    <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="card card-advance-table">
                <div class="card-header">
                    <h4 class="card-title">List Configuration</h4>
                    <div class="card-header-action">
                       <button type="button" class="btn btn-primary btn-round btn-shadow" (click)="openConfigModal(false);" title="Add" ><i class="fa fa-plus"></i> Add</button>
                    </div>
                </div>
                <div class="card-body">
                     <vio-table *ngIf="showConfigTable" [tableConfig]="paraTableConfig" [tableData]="paraTableData" (buttonClickEvent)="buttonClickEvent($event)" [tableHeader]="paraTableHeader"></vio-table>  <!--(rowSelectionChange)="changeevent($event)"-->
                </div>
            </div>
        </div>
    </div>
</div> 
